// CSV that Excel opens correctly: UTF-8 with BOM (diacritics), CRLF line ends,
// and a separator that does not clash with the locale's decimal mark
// (Czech, Polish and German use a decimal comma, so the separator is ';').

export function csvSeparator(locale) {
  const decimal = (1.5).toLocaleString(locale).charAt(1);
  return decimal === ',' ? ';' : ',';
}

// Number with the locale's decimal mark and no thousands grouping.
export const csvNumber = (n, locale, digits = 1) =>
  (n == null ? '' : n.toLocaleString(locale, { useGrouping: false, maximumFractionDigits: digits }));

const quote = (value, sep) => {
  const s = value == null ? '' : String(value);
  return /["\r\n]/.test(s) || s.includes(sep) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function toCsv(rows, sep) {
  return `﻿${rows.map(r => r.map(v => quote(v, sep)).join(sep)).join('\r\n')}\r\n`;
}

// Hands the file to the browser as a download.
export function downloadCsv(filename, rows, sep) {
  const blob = new Blob([toCsv(rows, sep)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
